import { useSelector } from 'react-redux'

import { selectInternalSimFlaws } from 'redux/selectors/internal/SimFlaws'

export const useInternalSimFlaws = () => {
  return useSelector(selectInternalSimFlaws)
}
